<script lang="ts" setup>
import { PageError } from '@brighterly/lib-lumee-ui'

import type { NuxtError } from '#app'

import { trackEvent } from '@shared/lib/amplitude'
import { startAnalytics } from '@entities/customer'

defineOptions({
  name: 'PageError',
})

const props = defineProps<{
  error: NuxtError
}>()

// A hard error can render before any page middleware started Amplitude; starting twice is a no-op.
void startAnalytics()
trackEvent('Page_view', {
  feature: 'error',
  name: 'error_page',
  error_code: props.error.statusCode ?? null,
  error_message: props.error.statusMessage || props.error.message || null,
})

const goHome = (): Promise<void> => clearError({ redirect: '/' })

</script>

<template>
  <main>
    <PageError @cta="goHome" />
  </main>
</template>
